<template>
	<div style="margin-right:50px">
	  <div class="subTop1">
	    <em>Innovative Practice</em>
	    <span>创新实践</span>
	    <router-link to="/shijian" class="more" @click.native="$track([['pagetype','首页-创新实践-更多-点击']])">更多</router-link>
	  </div>
	  <ul class="newsWap">
			<li v-for="(item,index) in shijianList.data" v-if="index<5">
				<a @click="jumppush('/detail/'+item.id)" :title="item.title">{{item.title}}</a>
			</li>
	    <!-- <li><a href="##">科技赋能为美好生活“添彩”——各地探索智慧公园</a></li>
	    <li><a href="##">数字化转型案例说 | 中国信通院助力湖北交投集团</a></li>
	    <li><a href="##">数字文旅在粤如何落地？十大数字化应用典型案例</a></li>
	    <li><a href="##">宁波市：以“一网统管”引领数字化改革 全力打造</a></li>
	    <li><a href="##">国外工业互联网安全产业布局情况及对我国的启示</a></li> -->
	  </ul>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isloading:true,
				shijianList: [],
			}
		},
		created:function(){
			this.shijianfnc();
		},
		computed: {
	
		},
		methods: {
			showLogin: function() {
				this.$emit('showLogin');
			},
			jumppush:function(to){
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			shijianfnc: function() {
				let _this = this;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'szjj/searchArticles',
						responseType: 'json',
						params: {
							columnID: '35f62e0da7c44340b7163804ceb28e70',
							// isTopArticle: '1',
							iPage:'1',
							pageSize:'5',
						},
					})
					.then(function(response) {
						// console.log(response);
						// debugger;
						_this.shijianList = response.data.data.data;
						_this.isloading=false;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
		}
	}
</script>

<style>
</style>
